import {toast, ToastContainer} from "react-toastify";
import TopAdminBar from "../../components/TopAdminBar";
import React, {useEffect, useState} from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./FindAndPrintStyle.css";
import {GET, PUT, request} from "../../api/ApiAdapter";
import ZebraBrowserPrintWrapper from "zebra-browser-print-wrapper";
import Footer from "../../components/Footer";
import {useHistory} from "react-router-dom";
import Confirm from "../../components/Confirm";

const FindAndPrint = () => {

    const  ZebraBrowserPrintWrapper = require('zebra-browser-print-wrapper');

    const [stockNo, setStockNo] = useState();
    const [usedVehicle, setUsedVehicle] = useState();
    // const [printerList, setPrinterList] = useState([]);
    const [selectedPrinter, setSelectedPrinter] = useState();
    const [confirmMsg, setConfirmMsg] = useState(false);
    const [isSmsQr, setIsSmsQr] = useState(null);

    // Create a new instance of the object
    const browserPrint = new ZebraBrowserPrintWrapper.default();

    const history = useHistory();

    const onInputChange = (e) => {
        setUsedVehicle();
        setStockNo(e.target.value);
    };

    const handleEnterKeypress = (e) => {
        if (e.key === 'Enter') {
            loadSigleUsedVehicle(stockNo);
        }
    };

    const onSearch = () => {
        loadSigleUsedVehicle(stockNo);
    };

    const loadSigleUsedVehicle = async (stockNo) => {
        try {
            let result = await request(`prints?stockNum=${stockNo}` , GET);
            if (!result.error) {
                if (result.content[0] === undefined){
                    toast.error("Vehicle not found");
                }
                else{
                    console.log(result.content[0]);
                    toast.info("Vehicle found");
                    setUsedVehicle(result.content[0]);
                }
            }
            else {
                console.log("Error");
                if (result.error.response.status === 401) {
                    console.log(result.error.response.status);
                    history.push("/page/login");
                }
            }
        } catch (e) {
            console.log(e);
        }
    };

    const loadIsSmsQrStatus = async () => {
        try {
            let result = await request(`accounts/issmsqr/${localStorage.getItem("accountId")}`, GET);
            if (!result.error) {
                setIsSmsQr(result);
            }
            else {
                console.log("Error");
                if (result.error.response.status === 401) {
                    console.log(result.error.response.status);
                    history.push("/page/login");
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        setUsedVehicle();
        loadIsSmsQrStatus();
    }, []);

    //========Printer Setting==========//

    const printLabels = async () => {
        if (selectedPrinter !== undefined) {
            // Set the printer
            await browserPrint.setPrinter(selectedPrinter);

            // Check printer status
            const printerStatus = await browserPrint.checkPrinterStatus();
            console.log("Get printer - ", await browserPrint.getPrinter());
            console.log("Printer Status - ", printerStatus);

            // Check if the printer is ready
            if (printerStatus.isReadyToPrint) {
                if(usedVehicle.printTemplate !== "") {
                    if (usedVehicle.url !== "" || isSmsQr) {
                        browserPrint.print(usedVehicle.printTemplate);
                        markAsPrinted(usedVehicle.id);
                    } else {
                        toast.error("URL not available");
                    }
                }
                else {
                    toast.error("print template is not available");
                }
            } else {
                toast.error("Printer - " + printerStatus.errors);
            }
        }
        else {
            toast.error("No printer selected");
        }
    }

    const markAsPrinted = async (usedVehicleLabelId) => {
        let result = await request(`prints/label/${usedVehicleLabelId}`, PUT, usedVehicleLabelId);
        if (!result.error) {
            toast.success("Label mark as printed.");
        } else {
            toast.error(result.error.response.data.message);
        }
    }

    useEffect( () => {
        console.log("selectedPrinter - ",JSON.parse(localStorage.getItem('printer')));
        const printerSelect = JSON.parse(localStorage.getItem('printer'));

        if (printerSelect !== null) {
            toast.success("Printer is selected");
            setSelectedPrinter(printerSelect);
        }
        else {
            toast.error("No printer selected");
        }
    },[])

    // const onInputPrinterChange = async (e) => {
    //     // Set the printer
    //     await browserPrint.setPrinter(printerList[e.target.value]);
    //     console.log("Selector Printer - ", printerList[e.target.value]);
    // }

    // let allPrinters;
    // const getPrintersList = async () =>{
        // Select all available printer
        // allPrinters = await browserPrint.getAvailablePrinters();
        // setPrinterList(allPrinters);
        // console.log("Printers List - ", allPrinters);
        // if(allPrinters.length > 0){
        //     toast.warn("Printers are Loading");
        // } else{
        //     toast.error("Error: No printers available");
        // }
    // }

    // useEffect(() => {
    //     getPrintersList();
    // },[])

    //========Printer Setting==========//


    //========Check Print Agent Availability==========//

    const refreshPage =  () => {
        window.location.reload(false);
    }

    const checkAgentAvailability = async () => {
        await browserPrint.getAvailablePrinters().then((res) => {
            localStorage.removeItem('agentNotActive');
            setConfirmMsg(false);
            console.log("Agent not available - ",JSON.parse(localStorage.getItem('agentNotActive')));

        }).catch(error => {
            toast.error("Zebra Browser Print not found");
            localStorage.setItem('agentNotActive', JSON.stringify(true));
            setConfirmMsg(JSON.parse(localStorage.getItem('agentNotActive')));
            console.log("Agent not available - ",JSON.parse(localStorage.getItem('agentNotActive')));
        });
    }

    useEffect(() => {
        checkAgentAvailability();
    }, []);

    //========Check Print Agent Availability==========//


    return(
        <>
            <ToastContainer
                position="bottom-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme='colored'
            />
            <div className="bg-white h-screen">
                <TopAdminBar/>
                <div className="ml-64 top-1 mt-6 left-0 flex items-center overflow-auto">
                    <div className="screenSize">
                        <Container className="mr-10 mt-6 ">
                            <Row>
                                <Col xs={3}></Col>
                                <Col xs={6}>
                                    <div><b className="text-lg mt-20">Print Single Label</b></div>
                                    <div className="flex gap-8 mt-8 mb-8 ml-4">
                                            <label
                                                htmlFor="last-name"
                                                className="block text-sm font-bold text-gray-700 mt-2"
                                            >
                                                Stock Num
                                            </label>
                                            <div className="relative font-medium text-sm text-gray-700 w-96">
                                                <input
                                                    type="text"
                                                    id="stockNum"
                                                    name="stockNum"
                                                    onChange={(e) => onInputChange(e)}
                                                    onKeyPress={(e) => handleEnterKeypress(e)}
                                                    placeholder="Enter Stock No"
                                                    autoComplete="family-name"
                                                    className="mt-1 focus:ring-green-500 focus:border-green-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md p-2 bg-gray-100"
                                                />
                                            </div>
                                            <button
                                                className="bg-primary-light-blue text-white font-poppins px-8 rounded-lg hover:bg-green-500 inline-flex items-center shadow-md"
                                                onClick={onSearch}
                                            >
                                                Search
                                            </button>
                                    </div>
                                    { usedVehicle ? (
                                        <div className="bg-primary-light-blue rounded-2xl pt-3 pb-3 text-white mb-8 mt-8">
                                            <Row>
                                                <Col xs={5}>
                                                    <p className="ml-12 text-2xl"><b>STOCK</b></p>
                                                    <p className="ml-12 text-2xl"><b>VIN</b></p>
                                                    <p className="ml-12 text-2xl"><b>YEAR</b></p>
                                                    <p className="ml-12 text-2xl"><b>MAKE</b></p>
                                                    <p className="ml-12 text-2xl"><b>MODEL</b></p>
                                                    <p className="ml-12 text-2xl"><b>MILEAGE</b></p>
                                                    <p className="ml-12 text-2xl"><b>EXTERIORCOLOUR</b></p>

                                                </Col>
                                                <Col xs={1}>
                                                    <p className="text-2xl"><b>:</b></p>
                                                    <p className="text-2xl"><b>:</b></p>
                                                    <p className="text-2xl"><b>:</b></p>
                                                    <p className="text-2xl"><b>:</b></p>
                                                    <p className="text-2xl"><b>:</b></p>
                                                    <p className="text-2xl"><b>:</b></p>
                                                    <p className="text-2xl"><b>:</b></p>
                                                </Col>
                                                <Col xs={6}>
                                                    <p className="text-2xl"><b>{usedVehicle.stockNum}</b></p>
                                                    <p className="text-2xl"><b>{usedVehicle.vin}</b></p>
                                                    <p className="text-2xl"><b>{usedVehicle.year}</b></p>
                                                    <p className="text-2xl"><b>{usedVehicle.make}</b></p>
                                                    <p className="text-2xl"><b>{usedVehicle.model}</b></p>
                                                    <p className="text-2xl"><b>{usedVehicle.mileage}</b></p>
                                                    <p className="text-2xl"><b>{usedVehicle.exteriorColour}</b></p>
                                                </Col>
                                            </Row>
                                            {usedVehicle.url === "" ?
                                                <div className="text-danger text-center mt-4">
                                                    <p className="text-lg"><b>PENDING - WAITING FOR URL</b></p>
                                                </div>
                                                :
                                                null }
                                        </div>)
                                        :
                                        null
                                    }
                                    <div className="mb-8">
                                        <Row>
                                            <Col xs={4}>
                                            {/*    <form*/}
                                            {/*        method="post"*/}
                                            {/*        action="/instrumentType"*/}
                                            {/*        encType="multipart/form-data"*/}
                                            {/*    >*/}
                                            {/*        <div className="col-span-6 sm:col-span-3 flex">*/}
                                            {/*            <label*/}
                                            {/*                htmlFor="role"*/}
                                            {/*                className="block mt-1 text-sm font-medium text-gray-700 pr-4"*/}
                                            {/*            >*/}
                                            {/*                Printer*/}
                                            {/*            </label>*/}
                                            {/*            <select*/}
                                            {/*                name="selected_printer"*/}
                                            {/*                id="selected_printer"*/}
                                            {/*                disabled={usedVehicle === undefined}*/}
                                            {/*                onChange={(e) => onInputPrinterChange(e)}*/}
                                            {/*                className={usedVehicle === undefined ?*/}
                                            {/*                    "outline-none focus:ring-green-500 focus:border-green-500 block shadow-sm sm:text-sm  rounded-md p-2 bg-gray-400 text-gray-700" :*/}
                                            {/*                    "outline-none focus:ring-green-500 focus:border-green-500 block shadow-sm sm:text-sm  rounded-md p-2 bg-gray-100 text-gray-700"*/}
                                            {/*                }*/}
                                            {/*            >*/}
                                            {/*                <option disabled selected defaultChecked>*/}
                                            {/*                    Choose Printer Here*/}
                                            {/*                </option>*/}
                                            {/*                {printerList ?*/}
                                            {/*                    printerList.map((item, key) => {*/}
                                            {/*                        return (*/}
                                            {/*                            <option defaultValue="null" value={key} key={key}>*/}
                                            {/*                                {item.name}*/}
                                            {/*                            </option>*/}
                                            {/*                        );*/}
                                            {/*                    })*/}
                                            {/*                    : null*/}
                                            {/*                }*/}
                                            {/*            </select>*/}
                                            {/*        </div>*/}
                                            {/*    </form>*/}
                                            </Col>
                                            <Col xs={6}></Col>
                                            <Col xs={2}>
                                                <button
                                                    disabled={usedVehicle === undefined}
                                                    className={usedVehicle ?
                                                        "bg-primary-orange text-white font-poppins px-8 py-2 rounded-lg hover:bg-green-500 inline-flex items-center shadow-md" :
                                                        "bg-gray-300 text-white font-poppins px-8 py-2 rounded-lg inline-flex items-center shadow-md"
                                                        }
                                                    onClick={printLabels}
                                                >
                                                    Print
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                                <Col xs={3}></Col>
                            </Row>
                        </Container>
                    </div>
                </div>
                <Footer />
            </div>
            {confirmMsg? (
                <Confirm
                    onConfirm={refreshPage}
                />
            ) : null}
        </>
    );
}

export default FindAndPrint;